import classNames from 'styles/utils/classNames';

interface Props {
  /** Matches the compact seat height inside the mobile feed's 2x2 tile. */
  compact?: boolean;
}

/** The ∞ tile that ends an Open Play roster with no participant limit. */
export default function UnlimitedSeat({ compact = false }: Props) {
  return (
    <div
      className={classNames(
        'flex flex-col items-center justify-center rounded-lg bg-color-bg-lightmode-secondary pb-ds-sm pt-ds-xs dark:bg-color-bg-darkmode-secondary',
        compact ? 'h-full' : 'h-12',
      )}
    >
      <span className="flex h-6 items-center justify-center">
        <img src="/images/app/infinity.svg" alt="Unlimited" className="h-8 w-8" />
      </span>
      <span className="typography-product-button-label-xs text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        open
      </span>
    </div>
  );
}
